import React, { useEffect, useState } from "react";
import { Title } from "@vds/typography";
import { css } from "@emotion/react";
import {
  CompactColNew,
  CustomSLButton,
  FlexRow,
  UltraMediumText,
  SmallText,
  SLGridLayout,
  SLRowLayout,
  SLNotification,
} from "../../components/core/utility";
import { Loader } from "@vds/loaders";
import { Dialog } from "primereact/dialog";
import { isEqual } from "lodash";
import { FlexColumn } from "../../components/core/Utility/index";
import { updateNewrelicStats } from "../../../utility/newrelic";
import { generate } from "shortid";
import styled from "styled-components";
import { validateAddress } from "../../services/C4S Decommission - Replacement/validateAddress";
import { DropdownSelect } from "@vds/selects";
import { Input, RadioButtonGroup } from "@vds/inputs";
import {
  ADDRESS_REGEX,
  CITY_REGEX,
  EMAIL_REGEX_C360,
  NAME_REGEX,
  ZIP_REGEX,
  ZIP_CODE_LIMIT,
  INSTALLER_VENDOR_ID,
} from "../../constants/ValidationConstants";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "@vds/buttons";
import { getStatesList } from "../../services/C4S Decommission - Replacement/getStatesList";
import useOutsideClick from "../../customHook/use-outside-click";

const ButtonsWrapper = css`
  margin-top: 1rem;
  margin-left: 2px;
  @media (max-width: 1424px) {
    margin-top: 1rem;
  }
`;

export const CustomInput = styled(Input)`
  padding-bottom: 0.9rem;
  height: auto;
  padding-right: ${(props) => (props.paddingRight ? props.paddingRight : "")};
  & label {
    & p {
      font-size: 12px;
      color: ${(props) => (props.disabled ? "#d8dada" : "")};
    }
  }
  & input {
    font-size: 12px;
    height: ${(props) => (props.height ? props.height : "")};
    &:disabled {
      -webkit-text-fill-color: #000000;
      background-color: #ffffff;
      border-bottom: 1px solid #000000;
      border-top: 1px solid #dfe0e0;
      color: ${(props) => (props.disabled ? "#d8dada" : "")};
      opacity: ${(props) => (props.disabled ? "0.4" : "")};
    }
  }
  & span {
    width: ${(props) => (props.width ? props.width : "")};
    & span {
      & span {
        & div:not(:first-child) {
          & svg {
            display: none; // hide success tick icon
          }
        }
      }
    }
  }
`;

export const CustomDropdown = styled(DropdownSelect)`
padding-right: ${(props) => (props.paddingRight ? props.paddingRight : "")};
& div {
    margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "")};
    
    & label {
      & p {
        font-size: 12px;
        color: ${(props) => (props.disabled ? "#d8dada" : "")};
        & span {
          &::after {
            color: #747676;
          }
        }
      }
    }
  }
  }
  & select {
    font-size: 12px;
    color: ${(props) => (props.disabled || props.disableValue ? "#666b6b" : "")};
    &:disabled {
      -webkit-text-fill-color: #000000;
      background-color: #ffffff;
      border-bottom: 1px solid #000000;
      opacity: ${(props) => (props.disabled ? "0.4" : "")};
    }
  }
`;
const TextArea = styled(InputTextarea)`
  //min-width: 800px !important;
  left: 0px !important;
  border: 1px solid #b7b8b8 !important;
  border-radius: 4px !important;
  margin-top: 0px !important;
  height: 200px !important;
  width: 99% !important;
  // width: -webkit-fill-available !important;
  font-family: Verizon-NHG-eDS !important;
  font-size: 16px !important;
  font-weight: 400 !important;
`;

export const RadioButtonGroupWrapper = styled.div`
  div[role="radiogroup"] {
    border: 0.0625rem solid #d8dada;
    margin-bottom: 0.6rem;
    > div > label {
      > div:first-child > div {
        height: 1rem;
        width: 1rem;
        transform: translate(50%, 100%);
      }
      > div:last-child {
        font-size: 12px;
        font-family: Verizon-NHG-eTX;
        padding: 0.313rem 0.5rem;
        > span > span {
          font-size: 14px;
          font-family: Verizon-NHG-eTX;
        }
      }
    }
  }
`;

const AddEditVendorModal = ({ addEditVendorModalOpen, closePopup, isAddingVendor, editVendorData }) => {
  const [vendorData, setVendorData] = useState({
    vendorId: { value: "", error: false, errorText: "Enter Installer Vendor Id", success: false },
    vendorName: { value: "", error: false, errorText: "Enter vendor name", success: false },
    partnerName: { value: "", error: false, errorText: "Enter name", success: false },
    installerVendorEmail: { value: "", error: false, errorText: "Enter email", success: false },
    installerVendorPhone: { value: "", error: false, errorText: "Enter phone number", success: false },
    status: { value: "", error: false, errorText: "Select status", success: false },
    latitude: { value: "", error: false, errorText: "Enter Latitude", success: false },
    longitude: { value: "", error: false, errorText: "Enter Longitude", success: false },
    technicianName: { value: "", error: false, errorText: "Enter Technician Name", success: false },
    garageOnly: { value: "", error: false, errorText: "Select Garage Only", success: false },
    legacyInstallerId: { value: "", error: false, errorText: "Enter Legacy Installer Id", success: false },
    VMI: { value: "", error: false, errorText: "Select VMI", success: false },
    CMI: { value: "", error: false, errorText: "Select CMI", success: false },
    LCV: { value: "", error: false, errorText: "Select LCV", success: false },
    HGV: { value: "", error: false, errorText: "Select HGV", success: false },
    immobilizer: { value: "", error: false, errorText: "Select immobilizer", success: false },
    EVcertified: { value: "", error: false, errorText: "Select EV Certified", success: false },
    comments: { value: "", error: false, errorText: "Enter comment", success: false },
  });
  const [isAddBtnEnabled, setIsAddBtnEnabled] = useState(true);
  const [isValidatingAddress, setIsValidatingAddress] = useState(false);
  const [verifyAddressIsDisable, setVerifyAddressIsDisable] = useState(false);
  const [verifyAddressIsShown, setVerifyAddressIsShown] = useState(true);
  const [suggestionsIsShown, setSuggestionsIsShown] = useState(false);
  const [typedAddress, setTypedAddress] = useState("");
  const latitudeLongitudeEnabledCountry = "MEX";
  const [timezone, setTimezone] = useState("");
  const [mapUrl, setMapUrl] = useState("");
  const [notification, setNotification] = useState(null);
  const [zipCodeLimit, setZipCodeLimit] = useState(ZIP_CODE_LIMIT);
  const [zipRegex, setZipRegex] = useState(ZIP_REGEX);
  const [isCountrySelected, setIsCountrySelected] = useState(false);
  const [isZipCodeDisabled, setIsZipCodeDisabled] = useState(true);
  const [isLoading, setLoader] = useState(false);
  const [suggestedAddress, setSuggestedAddress] = useState({
    address: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
    latitude: "",
    longitude: "",
  });

  const handleClickOutside = () => {
    setNotification(null);
  };

  const clickRef = useOutsideClick(handleClickOutside);

  useEffect(() => {
    address.postalCode.value && handleAdressFields("postalCode", address.postalCode.value);
  }, [zipRegex]);

  const [address, setAddress] = useState({
    verified: false,
    historicalAddress: { value: "", error: false, errorText: "", success: false },
    address1: { value: "", error: false, errorText: "Enter address 1", success: false },
    address2: { value: "", error: false, errorText: "Enter address 2", success: false },
    city: { value: "", error: false, errorText: "Enter city", success: false },
    state: { value: "", options: [], allStateOptions: [], error: false, errorText: "Please Select State", success: false },
    postalCode: { value: "", error: false, errorText: "Enter postal code", success: false },
    country: { value: "", error: false, errorText: "Enter country", success: false },
  });

  useEffect(() => {
    getStateList();
    if (!isAddingVendor) {
      handleFields("vendorId", editVendorData.vendorId);
      handleFields("vendorName", editVendorData.vendorName);
      handleFields("partnerName", editVendorData.partnerName);
      handleFields("installerVendorEmail", editVendorData.email);
      handleFields("installerVendorPhone", editVendorData.phone);
      handleFields("status", editVendorData.status);
      handleAdressFields("address1", editVendorData.address1?.trim());
      handleAdressFields("address2", editVendorData.address2?.trim());
      handleAdressFields("city", editVendorData.city?.trim());
      handleAdressFields("state", editVendorData.state?.trim());
      handleAdressFields("postalCode", editVendorData.postalCode?.trim());
      handleAdressFields("country", editVendorData.country?.trim(), true);
      handleFields("latitude", editVendorData.latitude);
      handleFields("longitude", editVendorData.longitude);
      handleFields("technicianName", editVendorData.technicianName);
      handleFields("garageOnly", editVendorData.garageOnly);
      handleFields("legacyInstallerId", editVendorData.legacyInstallerId);
      handleFields("VMI", editVendorData.vmi);
      handleFields("CMI", editVendorData.cmi);
      handleFields("LCV", editVendorData.lcv);
      handleFields("HGV", editVendorData.hgv);
      handleFields("immobilizer", editVendorData.immobilizer);
      handleFields("EVcertified", editVendorData.evCertified);
      handleFields("comments", editVendorData.comments);
    }
  }, []);

  const notify = (content, type) => {
    setNotification(<SLNotification key={generate()} type={type} title={content} fullBleed={true} ref={clickRef} />);
  };

  const handleZipCodeBasedOnCountry = (country) => {
    setIsZipCodeDisabled(false);
    let limits = countryZipLimitsList[country.toUpperCase()];
    if (["GBR", "CAN", "IRL", "NLD"].includes(country)) {
      if (country === "IRL") {
        setZipRegex(new RegExp("^[A-Z0-9]{3} [A-Z0-9]{4}$"));
        setZipCodeLimit(limits[1] + 1);
      }
      if (country === "CAN") {
        setZipRegex(new RegExp("^[A-Z]\\d[A-Z] \\d[A-Z]\\d$"));
        setZipCodeLimit(limits[1] + 1);
      }
      if (country === "GBR") {
        setZipRegex(new RegExp(`^[A-Z0-9 ]{${limits[0]},${limits[1]}}$`));
        setZipCodeLimit(limits[1]);
      }
      if (country === "NLD") {
        setZipRegex(new RegExp("^[0-9]{4} [A-Z]{2}$"));
        setZipCodeLimit(7);
      }
    } else {
      setZipRegex(new RegExp(`^\\d{${limits[0]},${limits[1]}}$`));
      setZipCodeLimit(limits[1]);
    }
  };

  const getStateList = async () => {
    updateNewrelicStats();
    setLoader(true);
    let stateListResponse = await getStatesList();
    if (stateListResponse.status === 200 && stateListResponse?.data?.data?.length) {
      let options = stateListResponse.data.data.map((state) => ({
          ...state,
          stateName: state.erpStateCode + " - " + state.stateCode,
        })),
        value = "";
      let filteredOptions = [];
      if (editVendorData?.country) {
        filteredOptions = options.filter(
          (state) =>
            editVendorData?.country?.toLowerCase() === state?.countryCode?.toLowerCase() ||
            editVendorData?.country?.toLowerCase() === state?.erpCountryCode.toLowerCase()
        );
      }

      if (editVendorData?.state && filteredOptions.length) {
        value =
          filteredOptions.find(
            (state) =>
              editVendorData?.state?.toLowerCase() === state?.erpStateCode?.toLowerCase() ||
              editVendorData?.state?.toLowerCase() === state?.stateCode.toLowerCase()
          )?.erpStateCode ?? null;
      } else {
        value = null;
      }
      setAddress((prevState) => ({
        ...prevState,
        state: {
          ...prevState.state,
          value,
          options: filteredOptions,
          allStateOptions: options,
          error: !value,
          errorText: "Please Select State",
          success: !!value,
        },
      }));
    } else {
      setAddress((prevState) => ({
        ...prevState,
        state: {
          ...prevState.state,
          value: "",
          options: [],
          allStateOptions: [],
          error: true,
          errorText: "Unable to fetch state list due to an unexpected error",
          success: false,
        },
      }));
      notify("Unable to fetch state list due to an unexpected error", "error");
    }
    setLoader(false);
  };

  const handleAddessVerification = async () => {
    let data = {
      inputAddress: {
        addressLine1: address.address1.value,
        addressLine2: address.address2.value ? address.address2.value : "",
        city: address.city.value,
        stateProvince: address.state.value,
        postalCode: address.postalCode.value,
        country: address.country.value,
      },
    };
    setIsZipCodeDisabled(true);
    setVerifyAddressIsDisable(true);
    setIsValidatingAddress(true);
    let response = await validateAddress(data);
    setIsValidatingAddress(false);
    if (response.status === 200 && response?.data?.message.toLowerCase() === "success") {
      let responsedata = response?.data?.data;

      let stdAddress = responsedata?.standardizedInfo?.standardizedAddress;
      let userAddress = responsedata?.inputAddress;
      setTimezone(responsedata?.location?.timezone);
      let mapUrl =
        "https://tpawdicgva003.ebiz.verizon.com/vzconnect/index.html?marker=" +
        stdAddress?.latLong?.longitude +
        ";" +
        stdAddress?.latLong?.latitude +
        ";;phone%20309-377-3838;;Customer%20ABC%20trucking";
      setMapUrl(mapUrl);
      if (responsedata?.standardizedInfo?.passesVZValidation) {
        setVerifyAddressIsShown(false);
        let standardAddress = {
          address1: stdAddress?.addressLine1?.toLowerCase(),
          address2: stdAddress?.subLocation ? stdAddress?.subLocation?.toLowerCase() : "",
          city: stdAddress?.city?.toLowerCase(),
          state: stdAddress?.stateProvince?.toLowerCase(),
          postalCode: stdAddress?.postalCodeBase?.toLowerCase(),
          country: stdAddress?.iso3CountryCode?.toLowerCase(),
        };
        let userTypedAddress = {
          address1: userAddress?.addressLine1?.toLowerCase(),
          address2: userAddress?.addressLine2 ? userAddress?.addressLine2.toLowerCase() : "",
          city: userAddress?.city?.toLowerCase(),
          state: userAddress?.stateProvince?.toLowerCase(),
          postalCode: userAddress?.postalCode?.toLowerCase(),
          country: userAddress?.country?.toLowerCase(),
        };
        if (!isEqual(standardAddress, userTypedAddress)) {
          setSuggestedAddress({
            address: `${stdAddress?.addressLine1}, ${stdAddress?.subLocation ? stdAddress?.subLocation + ", " : ""}${stdAddress?.city}, ${
              stdAddress?.stateProvince
            }, ${stdAddress?.postalCodeBase}, ${stdAddress?.countryName}`,
            address1: stdAddress?.addressLine1,
            address2: stdAddress?.subLocation,
            city: stdAddress?.city,
            state: stdAddress?.stateProvince,
            postalCode: stdAddress?.postalCodeBase,
            country: stdAddress?.iso3CountryCode,
            latitude: stdAddress?.latLong?.latitude,
            longitude: stdAddress?.latLong?.longitude,
          });
          setTypedAddress(
            `${userAddress?.addressLine1}, ${userAddress?.addressLine2 ? userAddress?.addressLine2 + ", " : ""}${userAddress?.city}, ${
              userAddress?.stateProvince
            }, ${userAddress?.postalCode}, ${userAddress?.country}`
          );
          setSuggestionsIsShown(true);
        } else {
          setIsZipCodeDisabled(false);
          setAddress((prevState) => ({ ...prevState, verified: true }));
        }
      } else {
        setIsZipCodeDisabled(false);
        setVerifyAddressIsDisable(false);
        let oldNotification = notification;
        notify("We couldn't verify the entered address and couldn't find a close match", "error");
      }
    } else {
      setIsZipCodeDisabled(false);
      setVerifyAddressIsDisable(false);
      let oldNotification = notification;
      notify("Address validation failed due to an unexpected error", "error");
    }
    setIsValidatingAddress(false);
  };

  const countryZipLimitsList = {
    DEU: [5, 5],
    GBR: [4, 8],
    FRA: [5, 5],
    CAN: [6, 6],
    NLD: [4, 4],
    IRL: [7, 7],
    MEX: [5, 5],
    NZL: [4, 4],
    USA: [5, 5],
    AUS: [4, 4],
    AUT: [4, 4],
    BEL: [4, 4],
  };

  useEffect(() => {
    if (address.country.value === latitudeLongitudeEnabledCountry) {
      setVerifyAddressIsShown(false);
    } else {
      setVerifyAddressIsShown(true);
    }
    if (
      address.country.value &&
      address.address1.value.length >= 2 &&
      address.city.value.length >= 2 &&
      address.state.value !== "" &&
      address.postalCode.value.length === 5
    ) {
      setAddress((prevState) => ({ ...prevState, verified: true }));
    } else {
      setAddress((prevState) => ({ ...prevState, verified: false }));
    }
  }, [address.country.value, address.address1.value, address.address2.value, address.city.value, address.state.value, address.postalCode.value]);

  const handleAddressSelection = (verified = false) => {
    if (verified) {
      handleAdressFields("address1", suggestedAddress.address1);
      handleAdressFields("address2", suggestedAddress.address2);
      handleAdressFields("city", suggestedAddress.city);
      handleAdressFields("state", suggestedAddress.state);
      handleAdressFields("postalCode", suggestedAddress.postalCode);
      handleAdressFields("country", suggestedAddress.country);
      handleFields("latitude", suggestedAddress.latitude);
      handleFields("longitude", suggestedAddress.longitude);
    }
    setSuggestionsIsShown(false);
    setSuggestedAddress({
      address: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      postalCode: "",
      country: "",
      latitude: "",
      longitude: "",
    });
    setTypedAddress("");
    setAddress((prevState) => ({ ...prevState, verified: true }));
    setVerifyAddressIsShown(false);
    setIsZipCodeDisabled(false);
  };

  const CustomLoader = css`
    div[aria-label="loader overlay"] {
      position: relative;
      width: 1.5rem;
      height: 1.5rem;
      top: 1.5rem;
      > div {
        width: 1.5rem;
        height: 1.5rem;
      }
    }
  `;

  useEffect(() => {
    vendorData.vendorId.success &&
    vendorData.partnerName.success &&
    vendorData.installerVendorEmail.success &&
    vendorData.installerVendorPhone.success &&
    vendorData.status.success &&
    address.verified
      ? setIsAddBtnEnabled(false)
      : setIsAddBtnEnabled(true);
  }, [
    vendorData.vendorId.success,
    vendorData.partnerName.success,
    vendorData.installerVendorEmail.success,
    vendorData.installerVendorPhone.success,
    vendorData.status.success,
    address.verified,
  ]);

  useEffect(() => {
    if (
      address.address1.success &&
      address.city.success &&
      address.state.success &&
      address.country.success &&
      address.postalCode.success &&
      address.verified
    ) {
      setVerifyAddressIsDisable(false);
    } else {
      setVerifyAddressIsDisable(true);
    }
    address.country.value === "" ? setIsCountrySelected(false) : setIsCountrySelected(true);
  }, [address.address1.success, address.city.success, address.state.success, address.country.success, address.postalCode.success, address.verified]);

  const handleAdressFields = (field, value, validate = false, trim = false) => {
    if (!trim) {
      if (address.verified) {
        setAddress((prevState) => ({ ...prevState, verified: false }));
        setVerifyAddressIsShown(true);
      }
    }
    switch (field) {
      case "address1": {
        if (value.length) {
          if (ADDRESS_REGEX.test(value)) {
            setAddress((prevState) => ({ ...prevState, address1: { value, error: false, errorText: "Enter address 1", success: true } }));
          } else {
            setAddress((prevState) => ({ ...prevState, address1: { value, error: true, errorText: "Enter a valid address 1", success: false } }));
          }
        } else {
          setAddress((prevState) => ({ ...prevState, address1: { value: "", error: true, errorText: "Enter address 1", success: false } }));
        }
        break;
      }
      case "address2": {
        if (value && value.length) {
          if (ADDRESS_REGEX.test(value)) {
            setAddress((prevState) => ({ ...prevState, address2: { value, error: false, errorText: "Enter address 2", success: true } }));
          } else {
            setAddress((prevState) => ({ ...prevState, address2: { value, error: true, errorText: "Enter a valid address 2", success: false } }));
          }
        } else {
          setAddress((prevState) => ({ ...prevState, address2: { value: "", error: false, errorText: "Enter address 2", success: false } }));
        }
        break;
      }
      case "city": {
        value && value.length
          ? ADDRESS_REGEX.test(value)
            ? setAddress((prevState) => ({ ...prevState, city: { ...prevState.city, value, error: false, success: true } }))
            : setAddress((prevState) => ({
                ...prevState,
                city: { ...prevState.city, value, error: true, errorText: "Enter valid city", success: false },
              }))
          : setAddress((prevState) => ({
              ...prevState,
              city: { ...prevState.city, value: "", error: true, errorText: "Enter city", success: false },
            }));
        break;
      }
      case "state": {
        if (value && value.length) {
          let stateValue = validate
            ? address.state.options.find(
                (state) => value.toLowerCase() === state.erpStateCode.toLowerCase() || value.toLowerCase() === state.stateCode.toLowerCase()
              )?.erpStateCode ?? null
            : value;
          if (stateValue) {
            setAddress((prevState) => ({
              ...prevState,
              verified: false,
              state: { ...prevState.state, value: stateValue, error: false, success: true, errorText: "Please Select State" },
            }));
            //setAddress((prevState) => ({ ...prevState, postalCode: { value: "", error: true, errorText: "Enter postal code", success: false } }));
          } else {
            setAddress((prevState) => ({
              ...prevState,
              state: { ...prevState.state, value: "", error: true, errorText: "Please Select State", success: false },
            }));
            //setAddress((prevState) => ({ ...prevState, postalCode: { value: "", error: true, errorText: "Enter postal code", success: false } }));
            setVerifyAddressIsShown(true);
          }
        } else {
          address.state.allStateOptions.length &&
            setAddress((prevState) => ({
              ...prevState,
              state: { ...prevState.state, value: "", error: true, errorText: "Please Select State", success: false },
            }));
        }
        break;
      }
      case "postalCode": {
        value = value.replace(/[^A-Z0-9 ]/g, "");
        if (value && value.length) {
          if (zipRegex.test(value)) {
            setAddress((prevState) => ({ ...prevState, postalCode: { value, error: false, errorText: "Enter postal code code", success: true } }));
          } else {
            setAddress((prevState) => ({ ...prevState, postalCode: { value, error: true, errorText: "Enter a valid postal code", success: false } }));
          }
        } else {
          setAddress((prevState) => ({ ...prevState, postalCode: { value: "", error: true, errorText: "Enter postal code", success: false } }));
        }
        break;
      }
      case "country": {
        if (validate) {
          if (value && value.length) {
            setAddress((prevState) => ({
              ...prevState,
              country: { ...prevState.country, value, error: false, success: true },
              state: {
                ...prevState.state,
                value: "",
                options: prevState.state.allStateOptions.filter((state) => state.countryCode === value),
                error: prevState.state.value || prevState.state.error || !prevState.state.allStateOptions.length ? true : false,
                errorText: prevState.state.allStateOptions.length ? "Please Select State" : "Unable to fetch state list due to an unexpected error",
                success: false,
              },
            }));
            handleZipCodeBasedOnCountry(value);
            if (value !== latitudeLongitudeEnabledCountry) {
              handleFields("latitude", "");
              handleFields("longitude", "");
            }
          } else {
            setAddress((prevState) => ({
              ...prevState,
              country: { ...prevState.country, value: "Please Select", error: true, errorText: "Please select country", success: false },
              state: {
                ...prevState.state,
                value: "",
                options: prevState.state.allStateOptions.filter((state) => state.countryCode === value),
                error: true,
                errorText: prevState.state.allStateOptions.length ? "Please Select State" : "Unable to fetch state list due to an unexpected error",
                success: false,
              },
            }));
            setIsZipCodeDisabled(true);
            setZipCodeLimit(0);
          }
        } else {
          value && value.length
            ? CITY_REGEX.test(value) &&
              setAddress((prevState) => ({ ...prevState, country: { ...prevState.country, value, error: false, success: true } }))
            : setAddress((prevState) => ({
                ...prevState,
                country: { ...prevState.country, value, error: true, errorText: "Enter country", success: false },
              }));
        }
        break;
      }
    }
  };

  const handleFields = (field, value) => {
    switch (field) {
      case "vendorId": {
        if (value && value.length) {
          if (INSTALLER_VENDOR_ID.test(value)) {
            setVendorData((prev) => ({
              ...prev,
              [field]: { ...prev[field], value: value, error: false, errorText: "Enter vendor ID", success: true },
            }));
          } else {
            setVendorData((prev) => ({
              ...prev,
              [field]: { ...prev[field], value: value, error: true, errorText: "Enter a valid vendor ID", success: false },
            }));
          }
        } else {
          setVendorData((prev) => ({
            ...prev,
            [field]: { ...prev[field], value: "", error: true, errorText: "Enter vendor ID", success: false },
          }));
        }
        break;
      }
      case "vendorName": {
        if (value && value.length) {
          if (NAME_REGEX.test(value)) {
            setVendorData((prev) => ({
              ...prev,
              [field]: { ...prev[field], value: value, error: false, errorText: "Enter vendor name", success: true },
            }));
          } else {
            setVendorData((prev) => ({
              ...prev,
              [field]: { ...prev[field], value: value, error: true, errorText: "Enter a valid vendor name", success: false },
            }));
          }
        } else {
          setVendorData((prev) => ({
            ...prev,
            [field]: { ...prev[field], value: "", error: true, errorText: "Enter vendor name", success: false },
          }));
        }
        break;
      }
      case "partnerName": {
        if (value && value.length) {
          if (NAME_REGEX.test(value)) {
            setVendorData((prev) => ({
              ...prev,
              [field]: { ...prev[field], value: value, error: false, errorText: "Enter partner name", success: true },
            }));
          } else {
            setVendorData((prev) => ({
              ...prev,
              [field]: { ...prev[field], value: value, error: true, errorText: "Enter a valid partner name", success: false },
            }));
          }
        } else {
          setVendorData((prev) => ({
            ...prev,
            [field]: { ...prev[field], value: "", error: true, errorText: "Enter partner name", success: false },
          }));
        }
        break;
      }
      case "installerVendorPhone": {
        if (value && value.length) {
          let phoneRegex = /^([^a-zA-Z])+$/;
          if (phoneRegex.test(value)) {
            setVendorData((prev) => ({
              ...prev,
              [field]: { ...prev[field], value: value, error: false, errorText: "Enter phone number", success: true },
            }));
          } else {
            setVendorData((prev) => ({
              ...prev,
              [field]: { ...prev[field], value: value, error: true, errorText: "Enter a valid phone number", success: false },
            }));
          }
        } else {
          setVendorData((prev) => ({
            ...prev,
            [field]: { ...prev[field], value: "", error: true, errorText: "Enter phone number", success: false },
          }));
        }
        break;
      }
      case "installerVendorEmail": {
        if (value && value.length) {
          if (EMAIL_REGEX_C360.test(value)) {
            setVendorData((prev) => ({ ...prev, [field]: { ...prev[field], value: value, error: false, errorText: "Enter email", success: true } }));
          } else {
            setVendorData((prev) => ({
              ...prev,
              [field]: { ...prev[field], value: value, error: true, errorText: "Enter a valid email", success: false },
            }));
          }
        } else {
          setVendorData((prev) => ({ ...prev, [field]: { ...prev[field], value: "", error: true, errorText: "Enter email", success: false } }));
        }
        break;
      }
      case "status": {
        if (value) {
          setVendorData((prev) => ({ ...prev, [field]: { ...prev[field], value: value, error: false, success: true } }));
        } else {
          setVendorData((prev) => ({ ...prev, [field]: { ...prev[field], value: "", error: true, success: false } }));
        }
        break;
      }
      case "country":
      case "latitude": {
        if (value && value.length) {
          if (isFinite(value) && Math.abs(value) <= 90) {
            setVendorData((prevState) => ({
              ...prevState,
              [field]: { ...prevState[field], value: value, error: false, errorText: "Enter latitude", success: true },
            }));
          } else {
            setVendorData((prevState) => ({
              ...prevState,
              [field]: { ...prevState[field], value: value, error: true, errorText: "Enter a valid latitude", success: false },
            }));
          }
        } else {
          setVendorData((prevState) => ({
            ...prevState,
            [field]: { value: "", error: true, errorText: "Enter latitude", success: false },
          }));
        }
        break;
      }
      case "longitude": {
        if (value && value.length) {
          if (isFinite(value) && Math.abs(value) <= 180) {
            setVendorData((prevState) => ({
              ...prevState,
              [field]: { ...prevState[field], value: value, error: false, errorText: "Enter longitude", success: true },
            }));
          } else {
            setVendorData((prevState) => ({
              ...prevState,
              [field]: { ...prevState[field], value: value, error: true, errorText: "Enter a valid longitude", success: false },
            }));
          }
        } else {
          setVendorData((prevState) => ({
            ...prevState,
            [field]: { value: "", error: true, errorText: "Enter longitude", success: false },
          }));
        }
        break;
      }
      case "technicianName": {
        if (value) {
          if (NAME_REGEX.test(value)) {
            setVendorData((prev) => ({
              ...prev,
              [field]: { ...prev[field], value: value, error: false, errorText: "Enter technician name", success: true },
            }));
          } else {
            setVendorData((prev) => ({
              ...prev,
              [field]: { ...prev[field], value: value, error: true, errorText: "Enter a valid technician name", success: false },
            }));
          }
        } else {
          setVendorData((prev) => ({
            ...prev,
            [field]: { ...prev[field], value: "", error: true, errorText: "Enter a valid technician name", success: false },
          }));
        }
        break;
      }
      case "garageOnly":
      case "legacyInstallerId":
      case "VMI":
      case "CMI":
      case "LCV":
      case "HGV":
      case "immobilizer":
      case "EVcertified":
      case "comments": {
        if (value) {
          setVendorData((prev) => ({ ...prev, [field]: { ...prev[field], value: value, error: false, success: true } }));
        } else {
          setVendorData((prev) => ({ ...prev, [field]: { ...prev[field], value: "", error: true, success: false } }));
        }
        break;
      }
    }
  };

  return (
    <>
      <Loader active={isLoading} fullscreen />
      <Dialog
        visible={addEditVendorModalOpen}
        onHide={closePopup}
        focusOnShow={false}
        header={
          <FlexRow justifyContent="space-between" style={{ padding: "15px" }}>
            <div>{isAddingVendor ? <Title size="medium">Add Vendor Data</Title> : <Title size="medium">Edit Vendor Data</Title>}</div>
          </FlexRow>
        }
        breakpoints={{
          "960px": "90vw",
          "640px": "100vw",
          "700px": "98vw",
          "750px": "98vw",
          "800px": "98vw",
          "900px": "98vw",
          "950px": "98vw",
          "1000px": "98vw",
          "1050px": "98vw",
          "1100px": "98vw",
          "1150px": "98vw",
        }}
        style={{ width: "85vw", height: "95vw", overflowY: "scroll" }}
      >
        <SLGridLayout>
          <SLRowLayout>
            <CompactColNew colSizes={{ mobile: 4, tablet: 12, desktop: 3 }}>
              <CustomInput
                type="text"
                label="Vendor ID (Start with a 1)*"
                data-testid="input-vendor-id"
                error={vendorData.vendorId.error}
                errorText={vendorData.vendorId.errorText}
                success={vendorData.vendorId.success}
                value={vendorData.vendorId.value}
                onChange={(event) => handleFields("vendorId", event.target.value)}
              />
              <CustomInput
                type="text"
                label="Vendor Name"
                data-testid="input-vendor-name"
                error={vendorData.vendorName.error}
                errorText={vendorData.vendorName.errorText}
                success={vendorData.vendorName.success}
                value={vendorData.vendorName.value}
                onChange={(event) => handleFields("vendorName", event.target.value)}
              />
              <CustomInput
                type="text"
                label="Partner Name*"
                data-testid="input-partner-name"
                error={vendorData.partnerName.error}
                errorText={vendorData.partnerName.errorText}
                success={vendorData.partnerName.success}
                value={vendorData.partnerName.value}
                onChange={(event) => handleFields("partnerName", event.target.value)}
              />
              <CustomInput
                type="text"
                label="Installer Vendor Email*"
                data-testid="input-installer-vendor-email"
                error={vendorData.installerVendorEmail.error}
                errorText={vendorData.installerVendorEmail.errorText}
                success={vendorData.installerVendorEmail.success}
                value={vendorData.installerVendorEmail.value}
                onChange={(event) => handleFields("installerVendorEmail", event.target.value)}
              />
              <CustomInput
                type="text"
                label="Installer Vendor Phone*"
                data-testid="input-installer-vendor-phone"
                error={vendorData.installerVendorPhone.error}
                errorText={vendorData.installerVendorPhone.errorText}
                success={vendorData.installerVendorPhone.success}
                value={vendorData.installerVendorPhone.value}
                onChange={(event) => handleFields("installerVendorPhone", event.target.value)}
              />
              <CustomDropdown
                marginBottom="7px"
                paddingRight="5px"
                label="Status*"
                data-testid="dropdown-status"
                onChange={(e) => handleFields("status", e.target.value)}
                value={vendorData.status.value}
                errorText={vendorData.status.errorText}
                error={vendorData.status.error}
                success={vendorData.status.success}
              >
                <option value="">Please Select</option>
                <option value="Active">Yes</option>
                <option value="InActive">No</option>
              </CustomDropdown>
            </CompactColNew>
            <CompactColNew colSizes={{ mobile: 4, tablet: 12, desktop: 3 }}>
              <CustomInput
                type="text"
                label="Address 1*"
                data-testid="input-address1"
                error={address.address1.error}
                errorText={address.address1.errorText}
                success={address.address1.success}
                value={address.address1.value}
                onChange={(event) => handleAdressFields("address1", event.target.value)}
                onBlur={(e) => handleAdressFields("address1", e.target.value?.trim(), false, true)}
              />
              <CustomInput
                type="text"
                label="Address 2"
                data-testid="input-address2"
                error={address.address2.error}
                errorText={address.address2.errorText}
                success={address.address2.success}
                value={address.address2.value}
                onChange={(event) => handleAdressFields("address2", event.target.value)}
                onBlur={(e) => handleAdressFields("address2", e.target.value?.trim(), false, true)}
              />
              <CustomInput
                type="text"
                label="City*"
                data-testid="input-city"
                error={address.city.error}
                errorText={address.city.errorText}
                success={address.city.success}
                value={address.city.value}
                onChange={(event) => handleAdressFields("city", event.target.value)}
                onBlur={(e) => handleAdressFields("city", e.target.value?.trim(), false, true)}
              />
              <CustomDropdown
                marginBottom="7px"
                paddingRight="5px"
                label="Country*"
                data-testid="dropdown-country"
                onChange={(e) => handleAdressFields("country", e.target.value, true)}
                error={address.country.error}
                errorText={address.country.errorText}
                success={address.country.success}
                value={address.country.value ? address.country.value : "Please Select"}
              >
                <option value="">Please Select</option>
                {Object.keys(countryZipLimitsList).map((country) => (
                  <option key={country}>{country}</option>
                ))}
              </CustomDropdown>
              <CustomDropdown
                width="99%"
                marginBottom="7px"
                paddingRight="5px"
                type="text"
                label="State*"
                data-testid="dropdown-state"
                disabled={!address.country.value}
                hideErrorImg={address.state.error}
                error={address.state.error}
                errorText={address.state.errorText}
                value={address.state.value || "Please Select"}
                onChange={(event) => handleAdressFields("state", event.target.value)}
              >
                <>
                  <option disabled style={{ backgroundColor: "lightgrey" }}>
                    Please Select
                  </option>
                  {address.state.options.map((stateCode) => (
                    <option key={stateCode.stateCode} value={stateCode.erpStateCode}>
                      {stateCode.stateName}
                    </option>
                  ))}
                </>
              </CustomDropdown>
              <CustomInput
                type="text"
                label="Zip/Postal Code*"
                data-testid="input-zipcode"
                disabled={isZipCodeDisabled}
                error={address.postalCode.error}
                errorText={address.postalCode.errorText}
                success={address.postalCode.success}
                value={address.postalCode.value}
                maxLength={zipCodeLimit}
                onChange={(event) => handleAdressFields("postalCode", event.target.value)}
                onBlur={(e) => handleAdressFields("postalCode", e.target.value?.trim(), false, true)}
              />
              <FlexRow>
                {verifyAddressIsShown && (
                  <CustomSLButton data-testid="btn-validate-address" disabled={verifyAddressIsDisable} onClick={handleAddessVerification}>
                    Validate
                  </CustomSLButton>
                )}
                {isValidatingAddress && (
                  <FlexColumn css={CustomLoader}>
                    <Loader active fullscreen={false} data-testid="loader-validating-address" />
                    <SmallText bold css={{ paddingLeft: "2rem" }}>
                      Verifying address...
                    </SmallText>
                  </FlexColumn>
                )}
              </FlexRow>
              {suggestionsIsShown && (
                <div data-testid="suggestion-ui">
                  <UltraMediumText eDSFont fontSize="18px" marginBottom="0" marginTop="1rem">
                    Choose an option
                  </UltraMediumText>
                  <SmallText>We couldn&apos;t verify the entered address. We found a close match</SmallText>
                  <RadioButtonGroupWrapper>
                    <RadioButtonGroup
                      onChange={() => handleAddressSelection(true)}
                      error={false}
                      data={[
                        {
                          name: "group",
                          label: (
                            <>
                              <span>Use suggested address</span>
                              <mark css={{ fontSize: "10px", backgroundColor: "#d8dada", padding: "0rem 0.313rem", marginLeft: "0.313rem" }}>
                                Verified
                              </mark>
                            </>
                          ),
                          children: suggestedAddress.address,
                          value: "radioOne",
                          ariaLabel: "radio one",
                          "data-testid": "radio-suggested-address",
                        },
                      ]}
                    />
                    <RadioButtonGroup
                      onChange={() => handleAddressSelection()}
                      error={false}
                      data={[
                        {
                          name: "group",
                          label: (
                            <>
                              <span>Use address as typed</span>
                            </>
                          ),
                          children: typedAddress,
                          value: "radioTwo",
                          ariaLabel: "radio two",
                          "data-testid": "radio-typed-address",
                        },
                      ]}
                    />
                  </RadioButtonGroupWrapper>
                </div>
              )}
              {address.country.value === latitudeLongitudeEnabledCountry ? (
                <>
                  <CustomInput
                    type="text"
                    label="latitude"
                    data-testid="input-latitude"
                    disabled={!address.verified}
                    error={vendorData.latitude.error}
                    errorText={vendorData.latitude.errorText}
                    success={vendorData.latitude.success}
                    value={vendorData.latitude.value}
                    onChange={(event) => handleFields("latitude", event.target.value)}
                  />
                  <CustomInput
                    type="text"
                    label="Longitude"
                    data-testid="input-longitude"
                    disabled={!address.verified}
                    error={vendorData.latitude.error}
                    errorText={vendorData.latitude.errorText}
                    success={vendorData.latitude.success}
                    value={vendorData.longitude.value}
                    onChange={(e) => handleFields("longitude", e.target.value)}
                  />
                </>
              ) : null}
            </CompactColNew>
            <CompactColNew colSizes={{ mobile: 4, tablet: 12, desktop: 3 }}>
              <CustomInput
                type="text"
                label="Technician Name"
                error={vendorData.technicianName.error}
                errorText={vendorData.technicianName.errorText}
                success={vendorData.technicianName.success}
                value={vendorData.technicianName.value}
                onChange={(event) => handleFields("technicianName", event.target.value)}
              />
              <CustomDropdown
                marginBottom="7px"
                paddingRight="5px"
                label="Garage Only"
                error={false}
                onChange={(e) => handleFields("garageOnly", e.target.value)}
                value={vendorData.garageOnly.value}
              >
                <option disabled value="" selected>
                  Please Select
                </option>

                <option>Value 1</option>
                <option>Value 2</option>
              </CustomDropdown>
              <CustomInput
                type="text"
                label="Legacy Installer ID"
                error={false}
                value={vendorData.legacyInstallerId.value}
                onChange={(event) => handleFields("legacyInstallerId", event.target.value)}
              />
              <CustomDropdown
                marginBottom="7px"
                paddingRight="5px"
                label="VMI"
                error={false}
                onChange={(e) => handleFields("VMI", e.target.value)}
                value={vendorData.VMI.value}
              >
                <option disabled value="" selected>
                  Please Select
                </option>

                <option>Yes</option>
                <option>No</option>
              </CustomDropdown>
              <CustomDropdown
                marginBottom="7px"
                paddingRight="5px"
                label="CMI"
                error={false}
                onChange={(e) => handleFields("CMI", e.target.value)}
                value={vendorData.CMI.value}
              >
                <option disabled value="" selected>
                  Please Select
                </option>

                <option>Yes</option>
                <option>No</option>
              </CustomDropdown>
              <CustomDropdown
                marginBottom="7px"
                paddingRight="5px"
                label="LCV"
                error={false}
                onChange={(e) => handleFields("LCV", e.target.value)}
                value={vendorData.LCV.value}
              >
                <option disabled value="" selected>
                  Please Select
                </option>

                <option>Yes</option>
                <option>No</option>
              </CustomDropdown>
              <CustomDropdown
                marginBottom="7px"
                paddingRight="5px"
                label="HGV"
                error={false}
                onChange={(e) => handleFields("HGV", e.target.value)}
                value={vendorData.HGV.value}
              >
                <option disabled value="" selected>
                  Please Select
                </option>

                <option>Yes</option>
                <option>No</option>
              </CustomDropdown>
              <CustomDropdown
                marginBottom="7px"
                paddingRight="5px"
                label="Immobilizer"
                error={false}
                onChange={(e) => handleFields("immobilizer", e.target.value)}
                value={vendorData.immobilizer.value}
              >
                <option disabled value="" selected>
                  Please Select
                </option>

                <option>Yes</option>
                <option>No</option>
              </CustomDropdown>
              <CustomDropdown
                marginBottom="7px"
                paddingRight="5px"
                label="EV Certified"
                error={false}
                onChange={(e) => handleFields("EVcertified", e.target.value)}
                value={vendorData.EVcertified.value}
              >
                <option disabled value="" selected>
                  Please Select
                </option>

                <option>Yes</option>
                <option>No</option>
              </CustomDropdown>
            </CompactColNew>
            <CompactColNew colSizes={{ mobile: 4, tablet: 8, desktop: 3 }}>
              <SmallText fontWeight="normal">Comments</SmallText>
              <TextArea
                error={false}
                value={vendorData.comments.value}
                onChange={(e) => handleFields("comments", e.target.value)}
                maxLength={500}
                autoResize="none"
              />
              <SLRowLayout css={ButtonsWrapper}>
                {isAddingVendor ? (
                  <Button size="medium" width={150} primary disabled={isAddBtnEnabled} data-testid={isAddingVendor ? "btn-add" : "btn-save"}>
                    Add
                  </Button>
                ) : (
                  <Button size="medium" width={150} primary disabled={isAddBtnEnabled} data-testid={isAddingVendor ? "btn-add" : "btn-save"}>
                    Save
                  </Button>
                )}

                <Button secondary size="medium" css={{ marginLeft: "5px" }} onClick={closePopup} width={150} data-testid="btn-cancel">
                  Cancel
                </Button>
              </SLRowLayout>
            </CompactColNew>
          </SLRowLayout>
        </SLGridLayout>
      </Dialog>
    </>
  );
};
export default AddEditVendorModal;
